import { css } from '@emotion/react';
import { ContentLoader } from '@frontend/design-system';
import { SchedulingInstructionAccordionForm } from './scheduling-instruction-accordion-form';
import { SchedulingMode } from './types';

type Props = {
  locationId: string;
  mode: SchedulingMode;
  onChange: (locationId: string, newMode: SchedulingMode) => void;
  isLoading?: boolean;
};

export const SingleLocationSchedulingInstruction = ({ locationId, mode, isLoading, onChange }: Props) => {
  return (
    <div css={styles.container}>
      <ContentLoader show={isLoading} />
      <SchedulingInstructionAccordionForm mode={mode} onChange={(newMode) => onChange(locationId, newMode)} />
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-gap-lg);
    padding: var(--fabric-space-gap-lg);
    background-color: var(--fabric-color-surface-default);
    box-shadow: var(--fabric-card-shadow);
    border-radius: var(--fabric-radius-md);
    max-width: 700px;
  `,
};
